import mainViewMixin from '../mainViewMixin';
import NiotaClassicApiService from '@/services/niotaClassicApiService';
import cloneDeep from 'lodash/cloneDeep';
import get from 'lodash/get';
export default {
  name: 'ViewNiotaClassicConsumersConsumerDetails',
  mixins: [mainViewMixin],
  data: function () {
    return {
      consumerData: {},
      consumerTitle: '',
      consumerDescr: '',
      consumerMQTTdata: {}
    };
  },
  computed: {
    headerBG() {
      return './img/consumer.png';
    },
    cloading() {
      return this.$store.state.app.loading;
    }
  },
  watch: {
    $route() {
      this.loadConsumer();
    }
  },
  mounted() {
    this.loadConsumer();
  },
  methods: {
    loadConsumer() {
      if (!this.$route.params.id) {
        return;
      }
      this.$store.state.app.load = 10;
      this.$store.state.app.loading = true;
      NiotaClassicApiService.consumersGet(this.$route.params.id).then(data => {
        this.consumerData = data;
        this.consumerTitle = data.data.consumer.title;
        this.consumerDescr = data.data.consumer.description;
      }).catch(error => {
        console.error('Could not load consumer', error);
      }).finally(() => {
        this.$store.state.app.loading = false;
      });
    },
    updateConsumer() {
      this.$store.state.app.loading = true;
      let updateData = cloneDeep(this.$refs.editedConsumer.lclObject);
      updateData.applications = updateData.applications.map(x => parseInt(x.applicationId));
      NiotaClassicApiService.consumersUpdate(updateData.id, updateData).then(() => {
        this.$snack('Consumer saved!', 'success');
        this.pushToRouter('/niota-classic/consumers');
      }).catch(error => {
        if (error.response && error.response.data.err) {
          this.$snack(`Consumer not saved!\n ${error.response.data.err}`, 'error');
        } else {
          this.$snack('Consumer not saved!', 'error');
        }
      }).finally(() => {
        this.$store.state.app.loading = false;
      });
    },
    pushToRouter(path) {
      this.$router.push({
        path: path
      });
    },
    saveItem() {
      if (get(this.consumerData, 'data.consumer.type') === 'IEC-60870-5-104') {
        let iec104Validation = this.$refs.editedConsumer.validateDataPoints();
        if (iec104Validation) {
          this.updateConsumer();
        }
      } else {
        this.updateConsumer();
      }
    },
    cancelEdit() {
      this.pushToRouter('/niota-classic/consumers');
    }
  }
};